import {
  defaultCard,
  defaultCardWithContent,
  defaultCardWithText,
  defaultMobileCard,
} from "src/components/shared/Cards/sharedStyles";
import styled, { css } from "styled-components";

interface UserCardElementProps {
  picked: boolean;
  turned: boolean;
  lowestScore?: boolean;
  highestScore?: boolean;
}

export const UserCardElement = styled.div<UserCardElementProps>`
  ${defaultMobileCard}

  border: ${({ theme }) => theme.border.thin} solid;

  border-color: ${({ theme, lowestScore, highestScore }) =>
    highestScore
      ? theme.colors.cards.borders.red
      : lowestScore
      ? theme.colors.cards.borders.yellow
      : theme.colors.cards.borders.primary};

  background-color: ${({ picked, theme }) =>
    picked
      ? theme.colors.cards.fills.picked
      : theme.colors.cards.fills.unpicked};

  ${({ turned, theme }) =>
    turned &&
    css`
      ${defaultCardWithContent}
      ${defaultCardWithText}
      font-size: ${theme.fonts.sizes.xxs};
      background-color: ${theme.colors.cards.fills.inactive};
    `}

  @media ${({ theme }) => theme.mq.md} {
    ${defaultCard}

    font-size:${({ theme }) => theme.fonts.sizes.s};
  }
`;
